<template>
  <div
    class="legend"
    :transform="transform"
    @click="$emit('legendClick', { key: legendClutser, val: legnedBgColor })"
  >
    <span
      class="legend-rect"
      :style="`background-color:${legnedBgColor};`"
    ></span>
    <div class="legend-text">{{ legendText }}</div>
  </div>
</template>
<script>
export default {
  name: "LegendList",

  props: ["legendText", "legnedBgColor", "transform", "legendClutser"],
};
</script>
<style scoped>
.legend-rect {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}
.legend-text {
  display: inline-block;
  margin: 0px 10px;
  vertical-align: middle;
  text-anchor: end;
}
</style>
